/**
 * ReviewSummary — the read-only brief card on the wizard's final step.
 * Renders every generator section with its selected display value, in the
 * section registry's order. Unset or phase-locked fields show a dash.
 */
import React from 'react';
import { ClipboardCheck } from 'lucide-react';
import { SECTIONS } from '../../constants/generatorSections';

const ReviewSummary = ({ valueFor }) => (
  <div className="bg-white rounded-2xl border border-gray-200 p-6" data-testid="review-summary">
    <h3 className="text-sm font-semibold text-gray-900 flex items-center gap-2 mb-5">
      <ClipboardCheck className="w-4 h-4 text-purple-500" /> Your AI Brief
    </h3>
    <dl className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-8 gap-y-3">
      {SECTIONS.map(({ id, label }) => {
        const value = valueFor(id);
        return (
          <div key={id} className="flex items-baseline justify-between gap-3 border-b border-gray-50 pb-2">
            <dt className="text-xs text-gray-400">{label}</dt>
            <dd className={`text-sm text-right ${value ? 'text-gray-900 font-medium' : 'text-gray-300'}`}>
              {value || '—'}
            </dd>
          </div>
        );
      })}
    </dl>
  </div>
);

export default ReviewSummary;
